// BHP-1089: Linked Helper overview — Backend2.0 `GET /api/vps`, filtered to the
// `server-type=linked-helper` label. Replaces the legacy
// `/api/v1/linked-helper/hosting/servers` call that never resolved in the
// Backend2.0-only stack (infinite "please wait"). Rendering lives in the shared
// VpsServerList.
import VpsServerList from '../../features/vps/ui/VpsServerList';

export default function LinkedHelperVpsOverview(): JSX.Element {
  return (
    <VpsServerList
      serverType="linked-helper"
      detailsBasePath="/vps/linked-helper"
      noun="Linked Helper servers"
    />
  );
}
